import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isWritePage = location.pathname === "/" || location.pathname === "/prompt";
  const isLeaderboardPage = location.pathname === "/leaderboard";
  const isAboutPage = location.pathname === "/about";

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out",
        scrolled 
          ? "bg-background/80 backdrop-blur-md border-b border-white/10 py-3" 
          : "bg-transparent py-5"
      )}
    >
      <div className="container flex items-center justify-between">
        <Link 
          to="/" 
          className="text-3xl font-bold font-heading tracking-tight text-white hover:text-primary/90 transition-colors"
        >
          VibeWriter
        </Link>
        
        <nav className="flex items-center space-x-4 md:space-x-8">
          {!isWritePage && (
            <NavLink to="/" label="Write" currentPath={location.pathname} size="small" />
          )}
          {!isLeaderboardPage && (
            <NavLink to="/leaderboard" label="Leaderboard" currentPath={location.pathname} size="small" />
          )}
          {!isAboutPage && (
            <NavLink to="/about" label="About" currentPath={location.pathname} size="small" />
          )}
        </nav>
      </div>
    </header>
  );
}

interface NavLinkProps {
  to: string;
  label: string;
  currentPath: string;
  size?: "default" | "small";
}

function NavLink({ to, label, currentPath, size = "default" }: NavLinkProps) {
  const isActive = currentPath === to || (to !== '/' && currentPath.startsWith(to));
  
  return (
    <Link 
      to={to} 
      className={cn(
        "font-medium transition-colors hover:text-primary relative pb-1 group",
        isActive ? "text-primary" : "text-white/90",
        size === "default" ? "text-lg" : "text-sm md:text-base"
      )}
    >
      {label}
      <span 
        className={cn(
          "absolute bottom-0 left-0 w-full h-0.5 bg-primary transform origin-left transition-transform duration-300",
          isActive ? "scale-x-100" : "scale-x-0 group-hover:scale-x-100"
        )}
      />
    </Link>
  );
}
